import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Sowmya Muthyala',
    title: "Aspiring Bioinformatician",
    desciption:" I am a driven Bioinformatics graduate from Northeastern University with profound experience in data analytics, omics and chemoinformatics. ",
    image: 'SM.jpeg',
    resumePdf: resume
}
